import {
    metrics as mStyles
} from "../styles/ChallanStyles";
export const MetricCard = ({ metric }) => (
    <div style={mStyles.card}>
        <div style={mStyles.label}>{metric.label}</div>
        <div style={mStyles.value(metric.color)}>{metric.value}</div>
        {metric.bar != null && (
            <div style={mStyles.bar.wrap}>
                <div style={mStyles.bar.fill(metric.bar, metric.color)} />
            </div>
        )}
        <div style={mStyles.sub}>{metric.sub}</div>
    </div>
);
